import React from 'react';
import { motion } from 'framer-motion';

const Footer: React.FC = () => {
  return (
    <footer className="bg-gradient-to-br from-forest-600 to-olive-600 text-cream-50 py-10">
      <div className="container-max section-padding">
        <div className="text-center">
          {/* Main content */}
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8 }}
            viewport={{ once: true }}
            className="mb-12"
          >
            <div className="flex items-center justify-center gap-6 mb-6">
              <div className="text-4xl select-none">🤍</div>
              <div className="text-4xl select-none">🤍</div>
              <div className="text-4xl select-none">🤍</div>
            </div>
            <h2 className="font-wasted text-4xl font-normal text-wedding-primary mb-6">
              Ale y Loren
            </h2>
            <p className="text-xl md:text-2xl font-light mb-6 opacity-90">
              17 / 10 / 2026
            </p>
          </motion.div>
          {/* Bottom section */}
          <motion.div
            initial={{ opacity: 0 }}
            whileInView={{ opacity: 1 }}
            transition={{ duration: 0.8, delay: 0.6 }}
            viewport={{ once: true }}
            className="border-t border-cream-50/20 pt-8"
          >
            <p className="text-sm opacity-60 mb-4">
              Con mucha emoción, esperamos verte en nuestro día especial.
            </p>
          </motion.div>
        </div>
      </div>

      {/* Scroll to top button */}
      <motion.button
        initial={{ opacity: 0 }}
        whileInView={{ opacity: 1 }}
        transition={{ duration: 0.8 }}
        viewport={{ once: true }}
        onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
        className="fixed bottom-8 right-8 bg-olive-600 hover:bg-olive-700 text-cream-50 p-3 rounded-full shadow-lg transition-all duration-300 hover:scale-110 z-50"
        aria-label="Volver arriba"
      >
        <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 10l7-7m0 0l7 7m-7-7v18" />
        </svg>
      </motion.button>
    </footer>
  );
};

export default Footer; 
